$(document).ready(function () {

  $("#explore_wine").owlCarousel({
    loop: true,
    lazyLoad: true,
    nav: true,
    navText: [
      `<img class="nav-arrow owl-next-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_3.png?v=1728998335">`,
      `<img class="nav-arrow owl-prev-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_2.png?v=1728998302">`,
    ],
    dots: false,
    slideBy: 1,
    items: 1,
    margin: 20,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1.6,
        margin: 13,
      },
      768: {
        items: 2.7,
      },
      1024: {
        items: 2.7,
      },
      1440: {
        items: 3.7,
      },
    },
  });

  $("#image_slider").owlCarousel({
    loop: true,
    margin: 10,
    lazyLoad: true,
    center: false,
    nav: false,
    dots: false,
    slideBy: 1,
    items: 4,
    responsiveClass: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: false,
    autoplaySpeed: 600,
    responsive: {
      0: {
        items: 2.5,
        margin: 15,
        center: true,
      },
      768: {
        items: 2.8,
        margin: 20,
      },
      1024: {
        items: 4.5,
        margin: 27,
      },
      1440: {
        items: 5.8,
        margin: 25,
        center: true,
        
      },
    },
  });
  $("#cheers_review_slider").owlCarousel({
    loop: true,
    lazyLoad: true,
    nav: false,
    dots: true,
    slideBy: 1,
    items: 1,
    margin: 20,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1.3,
        center: true,
        margin: 14.89,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
      1440: {
        items: 3.02,
      },
    },
  });

  $("#testing_slider").owlCarousel({
    loop: true,
    lazyLoad: true,
    nav: true,
    navText: [
      `<img class="nav-arrow owl-next-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_3.png?v=1728998335">`,
      `<img class="nav-arrow owl-prev-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_2.png?v=1728998302">`,
    ],
    dots: false,
    slideBy: 1,
    items: 1,
    margin: 20,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        margin: 10,
        center: true,
        dots: true,
        nav: false,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 2,
      },
      1440: {
        items: 2.02,
      },
    },
  });

  $("#selecting_slider").owlCarousel({
    loop: true,
    lazyLoad: true,
    nav: false,
    dots: true,
    slideBy: 1,
    items: 1,
    margin: 133,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        center: true,
        margin: 20,
      },
      768: {
        items: 2,
        margin: 50,
      },
      1024: {
        items: 2,
        margin: 100,
      },
      1440: {
        items: 2,
      },
    },
  });

  $(".collection-slider").owlCarousel({
    loop: true,
    lazyLoad: true,
    nav: true,
    navText: [
      `<img class="nav-arrow owl-next-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_3.png?v=1728998335">`,
      `<img class="nav-arrow owl-prev-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_2.png?v=1728998302">`,
    ],
    dots: false,
    slideBy: 1,
    items: 1,
    margin: 20,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1.4,
        margin: 10,
        dots: true,
      },
      768: {
        items: 2.2,
      },
      1024: {
        items: 3.2,
      },
      1440: {
        items: 4.2,
      },
    },
  });

  $("#semi_circular_slider").owlCarousel({
    loop: true,
    lazyLoad: true,
    center: true,
    nav: true,
    navText: [
      `<img class="nav-arrow owl-next-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_3.png?v=1728998335">`,
      `<img class="nav-arrow owl-prev-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_2.png?v=1728998302">`,
    ],
    dots: false,
    slideBy: 1,
    items: 1,
    margin: 194,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1.5,
        margin: 10,
        dots: true,
        nav: false,
      },
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
      1440: {
        items: 3,
      },
    },
  });

  $("#special_slider").owlCarousel({
    loop: true,
    lazyLoad: true,
    center: true,
    nav: true,
    navText: [
      `<img class="nav-arrow owl-next-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_3.png?v=1728998335">`,
      `<img class="nav-arrow owl-prev-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_2.png?v=1728998302">`,
    ],
    dots: false,
    slideBy: 1,
    items: 1,
    margin: 10,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        dots: true,
        nav: false,
      },
      768: {
        items: 1,
      },
      1024: {
        items: 1,
      },
      1440: {
        items: 1,
      },
    },
  });

  $("#semi_circular_slider").owlCarousel({
    loop: true,
    lazyLoad: true,
    center: true,
    nav: true,
    navText: [
      `<img class="nav-arrow owl-next-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_3.png?v=1728998335">`,
      `<img class="nav-arrow owl-prev-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_2.png?v=1728998302">`,
    ],
    dots: true,
    slideBy: 1,
    items: 1,
    margin: 10,
    responsiveClass: true,
    responsive: {
      0: {
        items: 2.5,
        dots: true,
        nav: false,
      },
      768: {
        items: 3.5,
      },
      1024: {
        items: 3.5,
      },
      1440: {
        items: 3.5,
      },
    },
  });

    $("#landing_product_slider").owlCarousel({
    loop: true,
    lazyLoad: true,
    nav: false,
    navText: [
      `<img class="nav-arrow owl-next-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_3.png?v=1728998335">`,
      `<img class="nav-arrow owl-prev-arrows" src="https://cdn.shopify.com/s/files/1/0563/9559/5851/files/Vector_2.png?v=1728998302">`
    ],
    dots: false,
    
    slideBy: 1,
    items: 1,
    margin: 20,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        margin: 10,
      },
      768: {
        items: 1,
      },
      1024: {
        items: 1,
      },
      1440: {
        items: 1,
      },
    },
  });

    // Click event for next image
    // $('.next-img').click(function() {
    //     $('.slider-button.slider-button--next').click(); // Trigger the next button
    // });

    // Click event for previous image
    // $('.prev-img').click(function() {
    //     $('.slider-button.slider-button--prev').click(); // Trigger the previous button
    // });


// let quantBtn = document.querySelectorAll('.discount-text span');
//   if(quantBtn){
//     quantBtn.forEach(function(btnEle){
//       btnEle.addEventListener('click', function(){
//         let btnText = btnEle.textContent;
//         // console.log('Text', btnText);
//         let fieldBox = document.querySelector('.quantity__input')
//         if(fieldBox){
//           fieldBox.value = btnText;
//           let event = new Event('change', {
//               bubbles: true,
//               cancelable: true
//           });
//           fieldBox.dispatchEvent(event);
//         }
//       })
//     })
//   }

});



// =======custom slider product========

// trigger carousel image on arrow click script start
const leftArrow = document.querySelector(
  ".custom-product-arrow-wrapper #left-arrow"
);
const rightArrow = document.querySelector(
  ".custom-product-arrow-wrapper #right-arrow"
);
const sliders = document.querySelectorAll("slider-component ul.slider");

const bottomSlider = sliders[1];

function updateArrowState() {
  const currentButton = bottomSlider.querySelector('button[aria-current="true"]');
  
  // Disable left arrow if it's the first button
  const firstButton = bottomSlider.querySelector("li:first-child button");
  if (currentButton === firstButton) {
    leftArrow.classList.add("disabled");
  } else {
    leftArrow.classList.remove("disabled");
  }

  // Disable right arrow if it's the last button
  const lastButton = bottomSlider.querySelector("li:last-child button");
  if (currentButton === lastButton) {
    rightArrow.classList.add("disabled");
  } else {
    rightArrow.classList.remove("disabled");
  }
}

rightArrow.addEventListener("click", function () {
  const currentButton = bottomSlider.querySelector('button[aria-current="true"]');
  if (currentButton) {
    const nextButton = currentButton.closest("li").nextElementSibling?.querySelector("button");
    if (nextButton) {
      nextButton.click();
      updateArrowState(); // Update arrow states after clicking
    }
  }
});

leftArrow.addEventListener("click", function () {
  const currentButton = bottomSlider.querySelector('button[aria-current="true"]');
  if (currentButton) {
    const prevButton = currentButton.closest("li").previousElementSibling?.querySelector("button");
    if (prevButton) {
      prevButton.click();
      updateArrowState(); // Update arrow states after clicking
    }
  }
});

// Initial state check
updateArrowState();
// trigger carousel image on arrow click script end



// =======custom slider product========


